<template>
  <div :class="s.wrap">
    <GlobalHeader :isDarkBackground="false" />
    
    <div :class="s.container">
      <div :class="s.content">
        <h1 :class="s.title">特定商取引法に基づく表記</h1>
        
        <div :class="s.section">
          <h2 :class="s.sectionTitle">事業者名</h2>
          <p :class="s.sectionContent">株式会社ｃｉｃａｃ</p>
        </div>

        <div :class="s.section">
          <h2 :class="s.sectionTitle">代表者名</h2>
          <p :class="s.sectionContent">代表取締役　今氏一路</p>
        </div>

        <div :class="s.section">
          <h2 :class="s.sectionTitle">所在地</h2>
          <p :class="s.sectionContent">
            東京都渋谷区西原 2-26-5
            <br>
            群馬県桐生市本町6-2
          </p>
        </div>

        <!-- <div :class="s.section">
          <h2 :class="s.sectionTitle">電話番号</h2>
          <p :class="s.sectionContent">お問い合わせフォームよりご連絡ください</p>
        </div> -->

        <div :class="s.section">
          <h2 :class="s.sectionTitle">メールアドレス</h2>
          <p :class="s.sectionContent">service@mitt.app</p>
        </div>

        <div :class="s.section">
          <h2 :class="s.sectionTitle">サービス内容</h2>
          <p :class="s.sectionContent">
            ・タクシー配車システム提供<br>
            ・ライドシェア配車システム提供<br>
            ・デマンド交通配車システム提供
          </p>
        </div>

        <!-- <div :class="s.section">
          <h2 :class="s.sectionTitle">料金</h2>
          <p :class="s.sectionContent"></p>
        </div> -->

        <!-- <div :class="s.section">
          <h2 :class="s.sectionTitle">お支払い方法</h2>
          <p :class="s.sectionContent"></p>
        </div> -->

        <div :class="s.section">
          <h2 :class="s.sectionTitle">返品・キャンセル</h2>
          <p :class="s.sectionContent">
            サービスの性質上、原則として返品・キャンセルはお受けできません。<br>
            ただし、当社の責に帰すべき事由がある場合はこの限りではありません。
          </p>
        </div>

        <div :class="s.section">
          <h2 :class="s.sectionTitle">免責事項</h2>
          <p :class="s.sectionContent">
            当社は、サービス利用によりお客様に生じた損害について、当社の故意又は重過失による場合を除き、一切の責任を負いません。
          </p>
        </div>
      </div>
      <!-- <div :class="[s.content, s.contact]">
        <div :class="s.contactSection">
          <h2 :class="s.sectionTitle">お問い合わせ</h2>
          <p :class="s.sectionContent">
            ご不明な点がございましたら、下記よりお気軽にお問い合わせください。
          </p>
          <div :class="s.contactLink">
            <a :class="s.contactButton" href="/form/">
              お問い合わせフォーム
            </a>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import GlobalHeader from '@/components/layouts/GlobalHeader.vue';

export default {
  name: 'SpecifiedCommercialTransaction',
  components: {
    GlobalHeader,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" module="s">
.wrap {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.container {
  margin: auto;
  width: min(100% - 80px * 2, 800px);
  flex: 1;
  padding-top: 120px;
  padding-bottom: 80px;
  
  @include mdView {
    width: min(100% - 50px * 2, 800px);
  }
  
  @include smView {
    width: max(100% - 20px * 2, 350px);
    padding-top: 100px;
    padding-bottom: 60px;
  }
}

.content {
  background-color: white;
  padding: 60px 80px;
  border-radius: 8px;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);

  &.contact {
    margin-top: 40px;
  }
  
  @include mdView {
    padding: 40px 60px;
  }
  
  @include smView {
    padding: 32px 24px;
  }
}

.title {
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 60px;
  color: #333;
  
  @include smView {
    font-size: 24px;
    margin-bottom: 40px;
  }
}

.section {
  margin-bottom: 40px;
  
  @include smView {
    margin-bottom: 32px;
  }
}

.sectionTitle {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 2px solid #f0f0f0;
  
  @include smView {
    font-size: 16px;
    margin-bottom: 8px;
  }
}

.sectionContent {
  font-size: 16px;
  line-height: 1.8;
  color: #666;
  
  @include smView {
    font-size: 14px;
    line-height: 1.7;
  }
}

.contactSection {
  text-align: center;
  @include smView {
    margin-top: 40px;
    padding-top: 32px;
  }
}

.contactLink {
  margin-top: 24px;
}

.contactButton {
  display: inline-block;
  background-color: #333;
  color: white;
  padding: 16px 32px;
  border-radius: 4px;
  text-decoration: none;
  font-weight: bold;
  transition: background-color 0.3s ease;
  
  &:hover {
    background-color: #555;
  }
  
  @include smView {
    padding: 12px 24px;
    font-size: 14px;
  }
}
</style>
